// extracted by mini-css-extract-plugin
module.exports = {"root":"PropertyList_root__2H9IB","twoColumns":"PropertyList_twoColumns__IYX91","item":"PropertyList_item__7Hj7W"};